import { fetchAuthSession, getCurrentUser, fetchUserAttributes } from 'aws-amplify/auth';

/**
 * Get current authenticated user info
 * Returns user object with sub, email, firmId, etc.
 */
export async function getCurrentUserInfo() {
  try {
    // Get the current authenticated user from Amplify v6
    const user = await getCurrentUser();
    
    // Get user attributes using the new v6 API
    const attributes = await fetchUserAttributes();
    
    // Build userInfo object
    const userInfo = {
      sub: user.userId || user.username,
      email: attributes.email || '',
      firmId: attributes['custom:firmId'] || 'default',
      name: attributes.name || '',
      ...attributes
    };
    
    return userInfo;
  } catch (error) {
    console.error('Error getting current user:', error);
    
    // Return a default user object if auth fails
    return {
      sub: 'guest-user',
      email: 'guest@example.com',
      firmId: 'default',
      name: 'Guest User'
    };
  }
}

/**
 * Check if user is authenticated
 */
export async function isAuthenticated() {
  try {
    await getCurrentUser();
    return true;
  } catch {
    return false;
  }
}